import { render, staticRenderFns } from "./ChoiceBox.vue?vue&type=template&id=1ec5cd13&scoped=true&"
import script from "./ChoiceBox.vue?vue&type=script&lang=js&"
export * from "./ChoiceBox.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceBox.vue?vue&type=style&index=0&id=1ec5cd13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec5cd13",
  null
  
)

export default component.exports